module.exports = __webpack_public_path__ + "img/druid.0994f428.png";